import { makeStyles } from "@material-ui/core/styles";

const mobile = "@media (max-width:759px)";
const compactControl = {
  "& .MuiOutlinedInput-root": { minHeight: 48, fontSize: 14 },
  "& .MuiOutlinedInput-input": { padding: "13px 14px" },
  "& .MuiSelect-select": { paddingRight: 32 },
  "& .MuiInputLabel-outlined": { fontSize: 14, transform: "translate(14px, 16px) scale(1)" },
  "& .MuiInputLabel-outlined.MuiInputLabel-shrink": { transform: "translate(14px, -6px) scale(0.75)" }
};
const compactNotice = { padding: "10px 12px", marginBottom: 12, fontSize: 13, lineHeight: 1.4 };

// Reservas-only overrides. Keep CControle's shared classes and breakpoints intact.
export default makeStyles({
  root: { "&&": { padding: 16, [mobile]: { padding: 12, alignItems: "flex-start" } } },
  shell: { "&&": {
    maxWidth: 1040, minHeight: 500, borderRadius: 18,
    gridTemplateColumns: "minmax(240px, 32%) minmax(0, 1fr)",
    [mobile]: { maxWidth: 560, minHeight: "auto", gridTemplateColumns: "minmax(0, 1fr)" }
  } },
  heroPanel: { "&&": { minHeight: 0, padding: 24, gap: 12, [mobile]: { padding: "16px 20px", gap: 0 } } },
  brandRow: { "&&": { gap: 12, alignItems: "flex-start", "& > .MuiBox-root": { minWidth: 0 } } },
  brandMark: { "&&": { width: 48, height: 48, minWidth: 48, borderRadius: 14 } },
  heroBrandIcon: { "&&": { width: 38, height: 38 } },
  eyebrow: { "&&": { fontSize: 10 } },
  title: { "&&": { fontSize: 23, lineHeight: 1.16, margin: "3px 0 8px", [mobile]: { fontSize: 20, margin: "2px 0 6px" } } },
  modePill: { "&&": { minHeight: 22, padding: "3px 8px", fontSize: 11 } },
  heroMascot: { "&&": {
    flex: "1 1 120px", minHeight: 120, maxHeight: 160, marginTop: 0, alignItems: "center", justifyContent: "center",
    "&::before": { left: "50%", width: 126, height: 21, bottom: 0 },
    [mobile]: { display: "none" }
  } },
  robotImage: { "&&": { position: "relative", width: 132, height: 148, maxHeight: 148, right: "auto", bottom: "auto", opacity: 1 } },
  stepsBox: { "&&": { gap: 6, marginTop: 0, [mobile]: { display: "none" } } },
  stepItem: { "&&": { minHeight: 34, gap: 8, padding: "6px 8px", fontSize: 11.5 } },
  stepNumber: { "&&": { width: 20, height: 20, minWidth: 20, fontSize: 11 } },
  contentPanel: { "&&": { minWidth: 0, padding: 24, [mobile]: { padding: 20 } } },
  panelTitle: { "&&": { fontSize: 22, [mobile]: { fontSize: 20 } } },
  panelSubtitle: { "&&": { margin: "7px 0 12px", fontSize: 13, lineHeight: 1.4 } },
  form: { "&&": { gap: 14, marginTop: 6 } },
  inputField: { "&&": compactControl },
  selectControl: { "&&": compactControl },
  connectionMeta: { "&&": {
    marginTop: 0, padding: "10px 12px", overflowWrap: "anywhere",
    "& .MuiTypography-root": { fontSize: 12, lineHeight: 1.4 },
    "& strong": { fontSize: 14, fontWeight: 800 }
  } },
  consent: { "&&": { margin: "12px 0 0", fontSize: 12, lineHeight: 1.4 } },
  actions: { "&&": {
    gap: 10, marginTop: 16, alignItems: "center", flexDirection: "row",
    "& > .MuiButton-root:first-child": { flex: 1 },
    [mobile]: { flexDirection: "column", alignItems: "stretch" }
  } },
  primaryButton: { "&&": { minHeight: 44, fontSize: 13, padding: "10px 14px" } },
  secondaryButton: { "&&": { minHeight: 44, fontSize: 13, padding: "8px 12px" } },
  alert: { "&&": compactNotice },
  success: { "&&": compactNotice }
}, { name: "ReservasLinkPopup" });
